var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-wrapper o-wrapper--huge c-wrapper"},[_c('vue-progress-bar'),_c('login',{attrs:{"type":"main"},on:{"login":function($event){return _vm.login($event)}}},[_c('div',{staticClass:"c-form--error",attrs:{"slot":"feedback"},slot:"feedback"},[_vm._v(_vm._s(_vm.feedback))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }